const { log } = console
const getVM = require('./utils/get-vm.js')
const gameStep = require('./utils/game-step.js')
const clearIoDevices = require('./utils/clear-io-devices.js')
const { handleMessages } = require('./utils/arcade-vm-hooks')
const {
  sanitizeSelections,
  sanitizeVariables
} = require('./utils/sanitize-state.js')
const VM_INTERVAL = 33

module.exports = function scratchvm (state, emitter) {
  emitter.on('load-vm', () => {
    log('load-vm')
    const RENDERER_WIDTH = 960
    const RENDERER_HEIGHT = 720

    state.canvas = document.createElement('canvas')
    state.canvas.id = 'scratch-canvas'
    state.canvas.width = 480
    state.canvas.height = 360
    state.canvas.classList.add('game')

    state.vm = getVM(state.canvas)
    state.vm.renderer.resize(RENDERER_WIDTH, RENDERER_HEIGHT)
    emitter.emit('render')
  })

  emitter.on('load-complete', () => {
    emitter.emit('add-document-event-listeners')
    clearIoDevices(state.vm.runtime)
    state.vm.runtime.currentStepTime = 1
    state.vm.greenFlag()
    state.loadedVM = true
    emitter.emit('play')
  })

  emitter.on('start-vm', () => {
    log('start-vm')
    clearInterval(state.vmInterval)
    state.vm.runtime._cloneCounter = -10000
    state.vmInterval = setInterval(() => {
      emitter.emit('game-step')
    }, VM_INTERVAL)
    sanitizeVariables(state)
    const node = state.vm.runtime.audioEngine.getInputNode()
    const volPercent = state.masterVolume / 100
    const gain = volPercent * volPercent
    node.gain.setValueAtTime(gain*2, 0)
    emitter.emit('render')
  })

  emitter.on('stop-vm', () => {
    log('stop-vm')
    clearInterval(state.vmInterval)
    const node = state.vm.runtime.audioEngine.getInputNode()
    node.gain.setValueAtTime(0, 0)
  })

  emitter.on('game-step', () => {
    if (state.isGamePlaying) {
      state.vm = gameStep(state.vm, state.glitchApplications)
      handleMessages(state.vm, emitter)
      sanitizeSelections(state)
    }
    emitter.emit('render')
  })
}
